// extracted by mini-css-extract-plugin
export default {"settingsPage":"SettingsPage_settingsPage__7+ckg"};